module.exports = __webpack_public_path__ + "static/media/latest-job-opening.ba804cc7.svg";